import {createSlice} from '@reduxjs/toolkit';

type StripeConfig = {
  annual_price_id: string;
  monthly_price_id: string;
  annual_trial_days: number;
};

type SliceState = {
  flags: Record<string, boolean>;
  stripeConfig: StripeConfig | null;
  donationEnabled: boolean;
};

const initialState: SliceState = {
  flags: {},
  stripeConfig: null,
  donationEnabled: false,
};

export const slice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setFeatureFlags: (
      state,
      {payload}: {payload: Record<string, boolean>},
    ) => {
      state.flags = payload;
    },
    setStripeConfig: (
      state,
      {payload}: {payload: StripeConfig | null},
    ) => {
      state.stripeConfig = payload;
    },
    setDonationEnabled: (state, {payload}: {payload: boolean}) => {
      state.donationEnabled = payload;
    },
  },
});

export const {setFeatureFlags, setStripeConfig, setDonationEnabled} =
  slice.actions;

export type {StripeConfig};

export default slice.reducer;
